export default {"src":"/_next/static/media/flag-vn.900e0566.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};